import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef1fc2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = { class: "grid-item" }
const _hoisted_3 = { class: "top-content" }
const _hoisted_4 = { class: "flex-col-centered" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = {
  class: "date-picker",
  style: {"width":"50%"}
}
const _hoisted_7 = ["disabled"]

import { computed, ref } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import PaymentItem from "@/Interfaces/Payments/ChurnPaymentItem";
import Popup from "./Popup.vue";
import CurrencyInput from "./CurrencyInput.vue";
import { MarketCurrency } from "@/services/helpers/Helper";
import { confirmChurnPayment } from "@/services/network";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import DateIgnoreTime from "@/types/DateIgnoreTime";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChurnPaymentPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const selectedRow = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const working = ref(false);
const selectedDate = ref<Date>();
const textInputOptions = { format: "yyyy/MM/dd" };
const paymentAmount = ref("");
const receivedOrSent = computed(() => {
    return +(selectedRow.value?.balance ?? 0) < 0 ? "transfer" : "receipt";
});
const paidOrReceived = computed(() => {
    return +(selectedRow.value?.balance ?? 0) < 0 ? "left to be paid" : "to be received";
});
const emits = __emit;
function closeChild(){
    selectedDate.value = undefined;
    paymentAmount.value = "";
    selectedRow.value = undefined;
}
const FormatDatePicker = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0].replaceAll("-", "/");
};
async function ConfirmTransfer() {
    if (working.value) return;
    working.value = true;
    const closeSpinner = useSpinnerPopup().show();
    try{
        if (!selectedRow.value) throw new ReferenceError('selectedRow cannot be null when submitting the form');
        const payload = Object.assign(selectedRow.value, {
            userEmail: authService.getEmailAddress(),
            balanceDateUpdated: new DateIgnoreTime(selectedDate.value),
            amountPaid: paymentAmount.value,
        });
        const response = await confirmChurnPayment.put(payload);
        useNotifierWithErrFormatter().success({ msg: "Payment successfully registered." });
        closeChild();
        emits("confirm");
    }catch (error) {
        useNotifierWithErrFormatter().error({
            name: `${__filename}/${ConfirmTransfer.name}`,
            errorType: 'Confirming payment',
            error
        });
    } finally {
        closeSpinner();
        working.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!selectedRow.value,
    "onUpdate:modelValue": closeChild,
    title: "Payment confirmation",
    hasClose: ""
  }, _createSlots({ _: 2 }, [
    (selectedRow.value)
      ? {
          name: "contents",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createTextVNode(" The remaining amount " + _toDisplayString(paidOrReceived.value) + " for this Churn ", 1),
              _createElementVNode("strong", null, _toDisplayString(selectedRow.value.journalInvoiceReference), 1),
              _createTextVNode(" is: "),
              _createElementVNode("strong", null, "£" + _toDisplayString(Math.abs(parseFloat(selectedRow.value.balance)).toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(" Please confirm the "),
              _createElementVNode("strong", null, _toDisplayString(receivedOrSent.value), 1),
              _createTextVNode(" of funds. ")
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(" Select a payment date and amount: "),
                _createElementVNode("form", {
                  onSubmit: _withModifiers(ConfirmTransfer, ["prevent"]),
                  title: "Select a date for confirmed tranfers",
                  class: "search-with-button"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(DatePicker), {
                      modelValue: selectedDate.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                      type: "date",
                      "enable-time-picker": false,
                      format: FormatDatePicker,
                      placeholder: "Select Date...",
                      "text-input-options": textInputOptions,
                      "text-input": "",
                      "max-date": new Date(),
                      teleport: true,
                      required: ""
                    }, null, 8, ["modelValue", "max-date"])
                  ]),
                  _createVNode(CurrencyInput, {
                    modelValue: paymentAmount.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentAmount).value = $event)),
                    max: Math.abs(+selectedRow.value.balance),
                    min: 0.01,
                    currency: _unref(MarketCurrency)[selectedRow.value.market],
                    style: {"border-radius":"0"},
                    required: ""
                  }, null, 8, ["modelValue", "max", "currency"]),
                  _createElementVNode("button", {
                    disabled: working.value,
                    class: "right-button"
                  }, " Confirm ", 8, _hoisted_7)
                ], 40, _hoisted_5)
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})